import useWrongEmailInstructionsHandlers from '../Utils/useWrongEmailInstructionsHandlers';
import ContentLink from './ContentLink';
import InstructionsSpanTypography from './InstructionsSpanTypography';
import UIStrings from '@/Utils/UIStrings';

function WrongEmailInstructions() {
    const { createNewAccountHandler, loginAgainHandler } = useWrongEmailInstructionsHandlers();

    return (
        <div className="text-sm leading-relaxed">
            <ContentLink onClick={createNewAccountHandler}>{UIStrings.CreateANewAccount}</ContentLink>
            <InstructionsSpanTypography>{` ${UIStrings.IfYouMistypedEmailPreviouslyOrTry} `}</InstructionsSpanTypography>
            <ContentLink onClick={loginAgainHandler}>{`${UIStrings.LogInAgain}`}</ContentLink>
            <InstructionsSpanTypography>{` ${UIStrings.WithAnotherEmail}`}</InstructionsSpanTypography>
        </div>
    );
}

export default WrongEmailInstructions;
